import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-bootstrap'
import { Box, HeadingStyled, LazyImage, MainHeading, PrimaryHeading, SpanStyled, TextStyled } from '../../ui/Elements'
import { AboutBg, AboutImg, AbtTxtImg, ArrowBtnBrown, ArrowBtnBrown2, ExpertiseBg, ExpIcon1, ExpIcon2, ExpIcon3, OurGoals, OurMission, OurVision, StatsBg1, StatsBg2, StatsBg3, StatsBg4, StripeBg, StripeBgAr } from '../../ui/AllImages'

import { useTranslation } from 'react-i18next'
import { AboutBox } from '../../ui/CustomElements'
import i18n from '../../Languages/INEXT'
import { AboutData } from '../projectData/Data'
import { Animate } from 'react-simple-animate'
const Expertise = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // When visible, set to true
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // run animation once
                }
            },
            {
                threshold: 0.2, // 20% of section visible triggers the animation
            }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);
    
    const start = i18n.language === "ar"
    ? { clipPath: "inset(0 0 0 100%)" }   // Arabic → reveal right → left
    : { clipPath: "inset(0 100% 0 0)" };  // English → reveal left → right
    const end = { clipPath: "inset(0 0% 0 0)" };
    const start2 = { opacity: 0, transform: 'translateY(-20px)' };
    const end2 = { opacity: 1, transform: 'translateY(0)' };
    
    return (
        <Box  id='ourExpertise'>
            <ExpWapper className='container-fluid secAbout common-space'  ref={sectionRef}>
                <Container>
                    <Row className='about-row'>
                        <Animate
                            play={isVisible}
                            duration={1.5}
                            delay={-1}
                            

                            start={start}
                            end={end}
                        >
                            <PrimaryHeading className='main-heading mb-5 primary-heading'>
                                {t('expH')}
                            </PrimaryHeading>
                        </Animate>
                        <Col md={12} className='about-h-row'>
                            <Animate
                                play={isVisible}
                                duration={1}
                                delay={.8}
                                start={start2}
                                end={end2}
                            >
                                <MainHeading className='main-heading mb-3 main-heading-about' size="40px">
                                    <SpanStyled className='expT1'>{t('expTxt')}</SpanStyled>  
                                </MainHeading>
                            </Animate>
                        </Col>
                        
                        <Animate
                            play={isVisible}
                            duration={1}
                            delay={1}
                            

                            start={start2}
                            end={end2}
                        >
                            <Col md={12} className='countingRow'>
                                <Row className='expCountRow'>
                                    <Col lg={4} md={12} className=''>
                                        <Box className='expCountNum'>
                                            01
                                        </Box>
                                    </Col>
                                    <Col lg={4} md={12} className=''>
                                        <Box className='expCountNum'>
                                            02
                                        </Box>
                                    </Col>
                                    <Col lg={4} md={12} className=''>
                                        <Box className='expCountNum'>
                                            03
                                        </Box>
                                    </Col>
                                </Row>
                            </Col>
                        </Animate>
                        <Col md={12} className=''>
                            <Row className=''>
                                <Col lg={4} md={12} className='colExp'>
                                    <Box className='whyChooseContent'>
                                        <Box className='why-c-wapper'>
                                            <Box className='w-choose-content'>
                                                <Box className='w-choose-icon'>
                                                    <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={2}
                                                        start={start2}
                                                        end={end2}
                                                    >
                                                        <ExpIcon1 />
                                                    </Animate>
                                                </Box>
                                                <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={2.5}
                                                        start={start2}
                                                        end={end2}
                                                    >
                                                    <Box className='pb-1'>
                                                        <Box  color='var(--themeColor)' className='hStyled hStyledMob'>
                                                            <Box className='expCountNum expCountNumMob'>
                                                                01 -&nbsp;
                                                            </Box>
                                                            {t('expTitle1')}
                                                        </Box>
                                                        <TextStyled>{t('expText1')}</TextStyled>
                                                    </Box>
                                                </Animate>
                                                <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={2.8}
                                                        start={start2}
                                                        end={end2}
                                                    >
                                                    <Box className='d-flex align-items-start gap-3 my-3'>
                                                        <Box className='serArrowList'>
                                                            <ArrowBtnBrown2 />
                                                        </Box>
                                                        <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL1T1')}</SpanStyled>
                                                    </Box>
                                                    <Box className='d-flex align-items-start gap-3 my-3'>
                                                        <Box className='serArrowList'>
                                                            <ArrowBtnBrown2 />
                                                        </Box>
                                                        <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL1T2')}</SpanStyled>
                                                    </Box>
                                                    <Box className='d-flex align-items-start gap-3 my-3'>
                                                        <Box className='serArrowList'>
                                                            <ArrowBtnBrown2 />
                                                        </Box>
                                                        <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL1T3')}</SpanStyled>
                                                    </Box>
                                                    <Box className='d-flex align-items-start gap-3 my-3'>
                                                        <Box className='serArrowList'>
                                                            <ArrowBtnBrown2 />
                                                        </Box>
                                                        <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL1T4')}</SpanStyled>
                                                    </Box>
                                                    <Box className='d-flex align-items-start gap-3 my-3'>
                                                        <Box className='serArrowList'>
                                                            <ArrowBtnBrown2 />
                                                        </Box>
                                                        <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL1T5')}</SpanStyled>
                                                    </Box>
                                                    <Box className='d-flex align-items-start gap-3 my-3'>
                                                        <Box className='serArrowList'>
                                                            <ArrowBtnBrown2 />
                                                        </Box>
                                                        <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL1T6')}</SpanStyled>
                                                    </Box>
                                                </Animate>
                                            </Box>
                                                
                                        </Box>
                                    </Box>
                                </Col>
                                <Col lg={4} md={12} className='colExp'>
                                    <Box className='whyChooseContent'>
                                        <Box className='why-c-wapper'>
                                            <Box className='w-choose-content'>
                                                <Box className='w-choose-icon'>
                                                    <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={2}
                                                        start={start2}
                                                        end={end2}
                                                    >
                                                    <ExpIcon2 />
                                                    </Animate>
                                                </Box>
                                                <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={2.5}
                                                        start={start2}
                                                        end={end2}
                                                    >
                                                <Box className='pb-1'>
                                                    <Box  color='var(--themeColor)' className='hStyled hStyledMob'>
                                                        <Box className='expCountNum expCountNumMob'>
                                                            02 -&nbsp;
                                                        </Box>
                                                        {t('expTitle2')}
                                                    </Box>
                                                    <TextStyled>{t('expText2')}</TextStyled>
                                                </Box>
</Animate>

                                                <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={2.8}
                                                        start={start2}
                                                        end={end2}
                                                    >
                                                <Box className='d-flex align-items-start gap-3 my-3'>
                                                    <Box className='serArrowList'>
                                                        <ArrowBtnBrown2 />
                                                    </Box>
                                                    <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL2T1')}</SpanStyled>
                                                </Box>
                                                
                                                <Box className='d-flex align-items-start gap-3 my-3'>
                                                    <Box className='serArrowList'>
                                                        <ArrowBtnBrown2 />
                                                    </Box>
                                                    <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL2T2')}</SpanStyled>
                                                </Box>
                                                <Box className='d-flex align-items-start gap-3 my-3'>
                                                    <Box className='serArrowList'>
                                                        <ArrowBtnBrown2 />
                                                    </Box>
                                                    <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL2T3')}</SpanStyled>
                                                </Box>
                                                <Box className='d-flex align-items-start gap-3 my-3'>
                                                    <Box className='serArrowList'>
                                                        <ArrowBtnBrown2 />
                                                    </Box>
                                                    <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL2T4')}</SpanStyled>
                                                </Box>
                                                <Box className='d-flex align-items-start gap-3 my-3'>
                                                    <Box className='serArrowList'>
                                                        <ArrowBtnBrown2 />
                                                    </Box>
                                                    <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL2T5')}</SpanStyled>
                                                </Box>
                                                <Box className='d-flex align-items-start gap-3 my-3'>
                                                    <Box className='serArrowList'>
                                                        <ArrowBtnBrown2 />
                                                    </Box>
                                                    <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL2T6')}</SpanStyled>
                                                </Box>
</Animate>
                                            </Box>
                                                
                                        </Box>
                                    </Box>
                                </Col>
                                <Col lg={4} md={12} className='colExp'>
                                    <Box className='whyChooseContent'>
                                        <Box className='why-c-wapper'>
                                            <Box className='w-choose-content'>
                                                <Box className='w-choose-icon'>
                                                    <Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={2}
                                                        start={start2}
                                                        end={end2}
                                                    >
                                                    <ExpIcon3 />
                                                    </Animate>
                                                </Box>
<Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={2.5}
                                                        start={start2}
                                                        end={end2}
                                                    >
                                                <Box className='pb-1'>
                                                    <Box  color='var(--themeColor)' className='hStyled hStyledMob'>
                                                        <Box className='expCountNum expCountNumMob'>
                                                            03 -&nbsp;
                                                        </Box>
                                                        {t('expTitle3')}
                                                    </Box>
                                                    <TextStyled>{t('expText3')}</TextStyled>
                                                </Box>
</Animate>
<Animate
                                                        play={isVisible}
                                                        duration={1}
                                                        delay={2.8}
                                                        start={start2}
                                                        end={end2}
                                                    >
                                                <Box className='d-flex align-items-start gap-3 my-3'>
                                                    <Box className='serArrowList'>
                                                        <ArrowBtnBrown2 />
                                                    </Box>
                                                    <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL3T1')}</SpanStyled>
                                                </Box>
                                                <Box className='d-flex align-items-start gap-3 my-3'>
                                                    <Box className='serArrowList'>
                                                        <ArrowBtnBrown2 />
                                                    </Box>
                                                    <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL3T2')}</SpanStyled>
                                                </Box>
                                                <Box className='d-flex align-items-start gap-3 my-3'>
                                                    <Box className='serArrowList'>
                                                        <ArrowBtnBrown2 />
                                                    </Box>
                                                    <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL3T3')}</SpanStyled>
                                                </Box>
                                                <Box className='d-flex align-items-start gap-3 my-3'>
                                                    <Box className='serArrowList'>
                                                        <ArrowBtnBrown2 />
                                                    </Box>
                                                    <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL3T4')}</SpanStyled>
                                                </Box>
                                                <Box className='d-flex align-items-start gap-3 my-3'>
                                                    <Box className='serArrowList'>
                                                        <ArrowBtnBrown2 />
                                                    </Box>
                                                    <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL3T5')}</SpanStyled>
                                                </Box>
                                                <Box className='d-flex align-items-start gap-3 my-3'>
                                                    <Box className='serArrowList'>
                                                        <ArrowBtnBrown2 />
                                                    </Box>
                                                    <SpanStyled className='mb-0 whyListTxt' color='var(--text)'>{t('expL3T6')}</SpanStyled>
                                                </Box>
                                                </Animate>
                                            </Box>
                                                
                                        </Box>
                                    </Box>
                                </Col>
                            </Row>
                        </Col>

                        {/* <Col lg={6} md={12} className='about-col about-col-img'>
                            <Box className='abouImg'>
                                <LazyImage src={AboutImg} />
                                
                            </Box>
                            
                            
                        </Col> */}
                    </Row>
                </Container>
                
            </ExpWapper>
            
        </Box>
    )
}
const ExpWapper = styled.section`
    background-image: url(${ExpertiseBg});
    background-size: cover;
    background-position: center center;
    .about-row {
        align-items: center;
    }
    .aboutContent{
        padding-right: 100px;
    }
    .main-heading-about{
        display: inline-block;
        padding-right: 200px;
        span{
            color: var(--text);
            display: unset;
            font-size: 40px;
            font-family: var(--familyRbt);
            font-weight: var(--semiBold);
            &.aboutH1, &.aboutH3{
                color: var(--themeColor);
            }
        }
    }
    .about-h-row{
        margin-bottom: 80px;
    }
    .hStyled{
        font-size: 24px;
        font-family: var(--familyRbt);
        font-weight: var(--semiBold);
        color: var(--themeColor);
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .abouImg{
        border-radius: 24px;
        overflow: hidden;
        span{
            width: 100%;
            height: 100%;
            img{
                width: 100%;
                height: auto;
            }
        }
    }
    .why-c-wapper{
        padding-right: 70px;
    }
    
    .expCountNum{
        font-size: 64px;
        font-family: var(--familyRbt) !important;
        font-weight: 400;
        color: var(--themeColor);
    }
    .expCountRow{
        padding-bottom: 50px;
        margin-bottom: 70px;
        border-bottom: 1px solid var(--text);
    }
    .expCountNumMob{
        display: none;
    }

    body.rtl &{
        .abtHeadSec{
            font-size: 24px;
        }
        .aboutContent{
            padding-right: 0px;
            padding-left: 100px;
        }
        .main-heading-about{
            display: inline-block;
            span{
                display: unset;
                font-size: 40px;
                font-family: var(--arSemiBold);
            }
        }
        .hStyled{
            margin-top: 15px;
            font-size: 28px;
            font-family: var(--arSemiBold);
        }
        .why-c-wapper{
            padding-left: 70px;
            padding-right: 0;
        }
        .expT1{
            padding-right: 0;
            /* padding-left: 200px; */
        }
        .main-heading-about{
            padding-right: 0;
            padding-left: 200px;
            span{
                
                font-family: var(--arSemiBold);
                
            }
        }
    }
    @media (max-width: 1199px) {
        .aboutContent {
            padding-right: 30px;
        }
        body.rtl &{
            .aboutContent{
                padding-right: 0px;
                padding-left: 30px;
            }
        }
    }
    @media (max-width: 991px) {
        .countingRow{
            display: none;
        }
        .about-col{
            margin-bottom: 40px;
        }
        .about-col-img{
            display: none;
        }
        &.secAbout{
            padding-top: 60px;
            padding-bottom: 30px;
        }
        .main-heading-about{
            font-size: 35px;
        }
        .aboutContent{
            padding-right: 0;
        }
        .main-heading-about{
            padding-right: 0;
            padding-right: 0;
            line-height: 1.1;
            span{
                font-size: 30px;
                
            }
        }
        .about-h-row{
            margin-bottom: 40px;
        }
        .colExp{
            margin-bottom: 40px;
        }
        .hStyledMob{
            display: flex;

        }
        .expCountNumMob{
            display: inline-block;
            font-size: 24px;
            font-weight: var(--semiBold);
        }
        .why-c-wapper {
            padding-left: 0px;
            padding-right: 0;
        }
        body.rtl &{
            .aboutContent{
                padding-right: 0px;
                padding-left: 0px;
            }
            .main-heading-about{
                padding-right: 0;
                padding-left: 0px;
                span{
                    
                    font-family: var(--arSemiBold);
                    font-size: 30px;
                }
            }
            .expCountNumMob{
                font-size: 28px;
                line-height: 45px;
            }
            .why-c-wapper {
                padding-left: 0px;
                padding-right: 0;
            }
        }
        
    }
    @media (max-width: 767px) {
        
    }
    @media (max-width: 575px) {
        &.secAbout{
            padding-top: 50px;
            padding-bottom: 20px;
        }
        .main-heading-about{
            font-size: 30px;
        }
    }
`
export default Expertise
